module.exports = __webpack_public_path__ + "img/80.e2df4941.jpg";